module.exports = __webpack_public_path__ + "static/media/certificados-bg.b1d12995.png";